<template>
   <el-collapse-item
      class='layer-group'
      :name="category.id"
      v-if="showCategory"
      >
      <template slot="title">
         <layer-group-header
            :category="category"
            :allLayersAreVisible="allLayersAreVisible"
            @toggle-all-layers="toggleAllLayers"
         />
      </template>
      <div v-if="hasSubGroups">
         <div v-for="group in regroupedLayers" :key="group.id" >
            <div class="sub-group-title">{{ group.title }}</div>
            <hr>
            <layer-checkbox
               v-for="layer in group.layers"
               :layer="layer"
               :key="layer.id"
            />
         </div>
      </div>
      <div v-else>
         <layer-checkbox
            v-for="layer in category.layers"
            :layer="layer"
            :key="layer.id"
         />
      </div>
   </el-collapse-item>
</template>

<script>
import { CollapseItem } from 'element-ui';
import LayerCheckbox from '../../../molecules/Home/LayerCheckbox';
import LayerGroupHeader from '../../../molecules/Home/LayerGroupHeader';

import { mapActions, mapGetters } from 'vuex';

export default {
   components: {
      LayerCheckbox,
      'el-collapse-item': CollapseItem,
      LayerGroupHeader,
   },
   props: {
      category: {
         type: Object,
         required: true,
         validator: ctgry => ctgry.layers instanceof Array && ctgry.title && ctgry.order
      },
   },
   computed: {
      ...mapGetters('plan', ['hasPlan']),
      allLayersAreVisible()
      {
         return this.category.layers.every(layer => layer.visible)
      },
      showCategory() {
         if (this.category.id!==-1) return true;
         return Boolean(this.hasPlan)
      },
      hasSubGroups()
      {
         return this.category.layers.some(layer => layer.sub_group)
      },
      regroupedLayers()
      {
         const layers = this.category.layers;
         const getTitle = layer => layer.sub_group ? layer.sub_group.title : 'Others';
         // haven't sorted by order because layers comes sorted from the database and 
         // if that doesn't hold, sort both the sub group title & the layers using
         // their order attribute
         const subGroupTitles = Array.from( new Set( layers.map(getTitle) ) );
         const regrouped = subGroupTitles.map((title,index) =>
         {
            return {
               id: index,
               title,
               layers: layers.filter(layer => getTitle(layer)===title)
            };
         });
         return regrouped;
      }
   },
   methods: {
      ...mapActions('layers', ['setLayerVisibleWithUI']),
      toggleAllLayers(visible)
      {
         this.category.layers.forEach( layer => 
         {
            this.setLayerVisibleWithUI({layer_id: layer.id, visible});
         });
      },
   }
}
</script>

<style lang="scss">
.layer-group {
   .el-collapse-item__arrow {
      display: none;
   }
   .sub-group-title
   {
      font-family: $secondary-font;
      color: $primary-color;
      font-size: 15px;
      font-weight: 500;
   }
   .sub-group-title + hr {
      margin-bottom: 10px;
      border-color: rgba($primary-color, 0.2);
   }
}
</style>